exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2PLgW{position:absolute;bottom:75px;right:25px;width:400px;min-height:200px;max-height:80%;border:1px solid #ccc;border-radius:3px;-webkit-box-shadow:0 0 3px rgba(0,0,0,.6);box-shadow:0 0 3px rgba(0,0,0,.6);background-color:#fff;padding:10px;display:none;overflow:auto}._2PLgW img{width:50px}._3XSHQ{margin:5px 0}._3XSHQ i{line-height:24px}", ""]);

// exports
exports.locals = {
	"modalVideoLlamadaUploads": "_2PLgW",
	"uploadedFile": "_3XSHQ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/ModalVideoLlamada/UploadsModalVideoLlamada/UploadsModalVideoLlamada.css
// module id = 1188
// module chunks = 0 1 2